<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="footer">
    <div class="footer-portal">
      <div class="options-wrap has-side-bars">
        <div class="clickable-link" @click="routeChange('WebStats')">{{ $t('statistics') }}</div>
        <router-link to="/links">{{ $t('head_links') }}</router-link>
        <router-link to="/quote-and-use-license">{{ $t('quote_and_license') }}</router-link>
      </div>
    </div>
    <div class="footer-corp">
      <div class="footer-inner has-side-bars">
        <a class="ajuntament-link" href="https://ajuntament.barcelona.cat/es/">
          <div class="icon-ajuntament" />
        </a>
        <div class="options-wrapper">
          <a :href="contactUrl" target="_blank" class="contact-link"
            >{{ $t('contact') }}
            <span class="icobcn-novafinestra2-l-light" aria-hidden="true">
              <span class="tooltip-text">Obre en una finestra nova</span>
            </span>
          </a>
          <a
            :href="
              currentLang === 'ca'
                ? 'https://www.barcelona.cat/ca/avis-legal'
                : currentLang === 'es'
                  ? 'https://www.barcelona.cat/es/aviso-legal'
                  : 'https://www.barcelona.cat/en/legal-notice'
            "
            >{{ $t('legal_adv') }}</a
          >
          <a :href="accesibilityLink">{{ $t('accesibility') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Footer of the webpage
 * @example [none]
 */
export default {
  name: 'Footer',
  computed: {
    currentLang() {
      return this.$store.state.i18n.lang
    },
    accesibilityLink() {
      if (this.$store.state.i18n.lang === 'ca')
        return 'https://ajuntament.barcelona.cat/declaracio-accessibilitat/ca/barcelona-dades'
      else if (this.$store.state.i18n.lang === 'es')
        return 'https://ajuntament.barcelona.cat/declaracio-accessibilitat/es/barcelona-datos'
      else return 'https://ajuntament.barcelona.cat/declaracio-accessibilitat/en/barcelona-datastore'
    },
    contactUrl() {
      if (this.$store.state.i18n.lang === 'ca') return 'https://www.bcn.cat/cgi-bin/consultesIRIS?id=1149'
      else if (this.$store.state.i18n.lang === 'es') return 'https://www.bcn.cat/cgi-bin/consultesIRIS?id=1150'
      else return 'https://www.bcn.cat/cgi-bin/consultesIRIS?id=1151'
    },
  },
  methods: {
    routeChange(routeName) {
      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName })
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.footer
  display: flex
  flex-direction: column

.footer-corp
  position: relative
  z-index: 3
  background-color: #FF2828

.footer-portal
  position: relative
  width: 100%
  z-index: 3
  display: flex
  align-items: center
  height: $footer-extend-height
  background-color: #fff
  border-top: 1px solid $light-grey
  border-bottom: 1px solid $light-grey

  .mobile &
    height: auto
    padding: vw(10px) 0

  .options-wrap
    display: flex
    justify-content: flex-end
    width: 100%
    gap: vw(18px)
    flex-wrap: wrap

    .mobile &
      flex-direction: column
      align-items: flex-start
      gap: vw(10px)
      margin-left: vw(170px)

    .clickable-link
      color: $grey
      cursor: pointer
      m-font-size(14, 18)

      &:hover
        text-decoration: underline

      .mobile &
        m-font-size(16, 25)

    > a
      display: block
      color: $grey
      m-font-size(14, 18)

      &:hover
        text-decoration: underline

      .mobile &
        m-font-size(16, 25)

.footer-inner
  display: flex
  justify-content: space-between
  align-items: center
  padding-top: vw(10px)
  padding-bottom: vw(10px)
  width: 100%

  /*
   * Evita el “salto” a layout raro con zoom extremo:
   * - Mantiene logo a la izquierda
   * - Mantiene links a la derecha
   * - Si no cabe, permite scroll horizontal (como el resto de la página)
   */
  flex-wrap: nowrap
  column-gap: vw(25px)

  .mobile &
    justify-content: center
    align-items: flex-start

  .icon-ajuntament
    width: vw(200px)
    height: vw(40px)
    background-image: url("https://www.barcelona.cat/assetsdi/img/2025/logo-negre.svg")
    background-position: center center
    background-size: cover
    background-repeat: no-repeat

    .mobile &
      position: absolute
      left: vw(10px)
      width: vw(90px)
      background-size: contain
      height: vw(35px)

  .options-wrapper
    m-font-size(16, 25)
    display: flex
    align-items: center
    gap: vw(25px)

    /*
     * Mantener los links en 1 línea (como en tu captura a +500%).
     * Si no cabe, que haga overflow horizontal (no wrap).
     */
    flex-wrap: nowrap
    white-space: nowrap

    .clickable-link
      color: $black
      cursor: pointer

      &:hover
        text-decoration: underline

    > a
      display: inline-flex
      align-items: center
      vertical-align: middle
      color: $black
      white-space: nowrap

      &:hover
        text-decoration: underline

    .mobile &
      flex-direction: column
      align-items: flex-start
      gap: vw(10px)

  .icobcn-novafinestra2-l-light {
    text-decoration: none;
    position: relative;
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    height: 16px;
    margin-left: 4px;
    top: 0;

    .tooltip-text {
      position: absolute;
      bottom: 80%;
      left: 100%;
      transform: translateX(-50%);
      margin-bottom: 6px;
      background-color: white;
      color: black;
      padding: 4px 8px;
      font-size: 12px;
      white-space: nowrap;
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transition-delay: 0s;
    }
  }

  .options-wrapper > a:hover .tooltip-text {
    opacity: 1;
    visibility: visible;
    transition-delay: 0.5s;
  }

  /*
   * Fuerza el "pegado" del icono al texto SOLO en el link de Contacte,
   * evitando espacios variables por saltos/line-height/whitespace.
   */
  .options-wrapper > a.contact-link {
    gap: 1px;
  }

  .options-wrapper > a.contact-link .icobcn-novafinestra2-l-light {
    margin-left: 0;
  }
</style>
